import * as React from "react";
import addUserIcon from "../../../assets/icons/add-user.svg";
import leaveIcon from "../../../assets/icons/leave.svg";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../services/functions/useFetch";
import { useUser, UserRole } from "../../../services/UserContext";

interface PopupProps {
  setLogoutConfirmed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Popup: React.FC<PopupProps> = ({ setLogoutConfirmed }) => {
  const navigate = useNavigate();
  const { role, refreshSession } = useUser();
  const { error, fetchData } = useFetch();

  const handleLogout = async () => {
    fetchData("/logout", "POST", {
      doOnSuccess: async () => {
        refreshSession(); // Refresh session to update role
        setLogoutConfirmed(true);
      },
      doOnError: () => {
        console.error("Failed to logout user. ", error);
      },
    });
  };

  // Do not render anything if role is user
  if (role === UserRole.USER) return null;

  return (
    <div className="popup">
      <div>
        {role === UserRole.ADMIN && (
          <button
            className="popup-button"
            onClick={() => {
              navigate("/register");
            }}
          >
            <img className="popup-icon" src={addUserIcon} alt="add-user" />
            Registrieren
          </button>
        )}
        {/*
        <button
          className="popup-button"
          onClick={() => {
            navigate("/session");
          }}
        >
          <img
            className="popup-icon"
            src={personQuestionIcon}
            alt="person-question"
          />
          Sessioncheck
        </button>
        */}
        <button
          className="popup-button"
          onClick={() => {
            handleLogout();
          }}
        >
          <img className="popup-icon" src={leaveIcon} alt="logout" />
          Abmelden
        </button>
      </div>
    </div>
  );
};

export default Popup;
